import { Action, ActionReducer } from '@ngrx/store';

export const LOCAL_STORAGE_STORE_KEY = '__frodo_storage__';

function setSavedState(state: any, key: string) {
  localStorage.setItem(key, JSON.stringify(state));
}

function getSavedState(key: string): any {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  } catch {
    return undefined;
  }
}

export function merge(target: any, source: any) {
  const result = target || {};
  return Object.entries(source || {}).reduce(
    (acc, [key, value]) => {
      acc[key] =
        value && typeof value === 'object' && !Array.isArray(value)
          ? merge(acc[key] && typeof acc[key] === 'object' ? acc[key] : {}, value)
          : value;
      return acc;
    },
    { ...result }
  );
}

export function storageMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
  let onInit = true;
  return function (state: S, action: A): S {
    const nextState = reducer(state, action);
    if (onInit) {
      onInit = false;
      const savedState = getSavedState(LOCAL_STORAGE_STORE_KEY);
      return merge(nextState, savedState);
    }
    setSavedState(nextState, LOCAL_STORAGE_STORE_KEY);
    return nextState;
  };
}
